import exp from "constants";

export const GET_LOCATION_REQUEST = 'GET_LOCATION_REQUEST';
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS';
export const GET_LOCATION_FAILURE = 'GET_LOCATION_FAILURE';

export const GET_LOCATION_BY_ID_REQUEST = 'GET_LOCATION_B_REQUESTY_ID';
export const GET_LOCATION_BY_ID_SUCCESS = 'GET_LOCATION_BID_Y_SUCCESS';
export const GET_LOCATION_BY_ID_FAILURE = 'GET_LOCATION_BY_ID_FAILURE';

export const GET_UNIT_REQUEST = 'GET_UNIT_REQUEST';
export const GET_UNIT_SUCCESS = 'GET_UNIT_SUCCESS';
export const GET_UNIT_FAILURE = 'GET_UNIT_FAILURE';

export const CREATE_APPOINTMENT_REQUEST = 'CREATE_APPOINTMENT_REQUEST';
export const CREATE_APPOINTMENT_SUCCESS = 'CREATE_APPOINTMENT_SUCCESS';
export const CREATE_APPOINTMENT_FAILURE = 'CREATE_APPOINTMENT_FAILURE';

export const CLEAR_APPOINTMENT = 'CLEAR_APPOINTMENT';

export const RESET_CREATE_VISITOR_ERROR = 'RESET_CREATE_VISITOR_ERROR';